<script lang="ts">
  import { i18n } from '../../util/i18n/i18n';
  import LogoLoader from './LogoLoader.svelte';
  import LogoSparkles from './LogoSparkles.svelte';

  export let loading: boolean;
</script>

<div>
  <div class="header-logo">
    <h1>
      {#if loading}
        <LogoLoader />
      {:else}
        <picture>
          <source srcset="mgp-logo.webp" type="image/webp" />
          <source srcset="mgp-logo.png" type="image/png" />
          <img
            class="logo"
            src="mgp-logo.png"
            width={290}
            height={290}
            alt={i18n('poll.logo-for', {
              values: { eventname: 'Melodi Grand Prix' },
            })}
          />
        </picture>
      {/if}
    </h1>
    <LogoSparkles />
  </div>
  <div class="header-gradient"></div>
</div>

<style>
  :global(#index-logo) {
    display: none !important;
  }

  .header-logo {
    width: 17.875rem;
    height: 17.875rem;
    display: grid;
    grid-template-areas: 'center';
    place-items: center;
    margin-top: -2rem;
  }

  .header-gradient {
    width: 30rem;
    max-width: 100%;
    height: 38rem;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
    background: radial-gradient(
      50% 50% at 50% 50%,
      #4e1b52 42.19%,
      rgba(78, 27, 82, 0.6) 74.99%,
      rgba(78, 27, 82, 0.613636) 75%,
      rgba(78, 27, 82, 0) 100%
    );
  }

  h1 {
    padding: 0;
    grid-area: center;
  }
</style>
